<template>
  <v-combobox
    v-if="editable"
    v-model="select"
    :items="items"
    :label="label"
    item-text="name"
    item-value="name"
    @change="onChange"
    clearable
    @click:clear="onClear"
    :outlined="outlinedInputs"
    :dense="dense"
    :hide-details="hideDetails"
  ></v-combobox>
  <v-select
    v-else
    :items="items"
    :label="label"
    item-text="name"
    item-value="name"
    v-model="select"
    @change="onChange"
    :outlined="outlinedInputs"
    :dense="dense"
    :hide-details="hideDetails"
  ></v-select>
</template>

<script>
import { ALL_INTERNAL_STATUSES_SEARCH_QUERY } from "../../../constants/graphql";
export default {
  name: "itinerary-internal-status-list-select",
  props: {
    value: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "Select or Add Status",
    },
    skipAutoselect: {
      type: Boolean,
      default: () => false,
    },
    dense: {
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
    editable: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      select: this.value != "" ? this.value : "",
    };
  },
  computed: {
    items() {
      return this.internalStatuses
        ? this.internalStatuses.edges.map((i) => ({ ...i.node }))
        : [];
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },
  methods: {
    onChange(event) {
      if (event) {
        this.$emit("input", event.name ? event.name : event);
      } else {
        this.$emit("input", "");
      }
    },
    onClear() {
      this.$emit("input", "");
    },
  },
  watch: {
    value(newVal) {
      this.select = newVal;
    },
  },
  apollo: {
    internalStatuses: {
      query: ALL_INTERNAL_STATUSES_SEARCH_QUERY,
      result({ data }) {
        if (this.value == "" && data.internalStatuses.edges.length > 0) {
          if (!this.skipAutoselect) {
            this.select = data.internalStatuses.edges[0].node.name;
            this.$emit("input", this.select);
          }
        }
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ItineraryStatusListSelect.vue